/* eslint-disable no-console */
// import { httpsCallable } from "firebase/functions";
// import { functions } from "../../config/firebase";
import firebase from "../../config/firebase";
import { IHotelBookingInput } from "../../common/types";
import { db } from "./firestoreService";
import {
  COLLECTION_BOOKING30512_HOTEL,
  COLLECTION_BOOKING30512_HOTEL_COUNT,
  COLLECTION_EXCLUSIVEHOTEL64774,
  COLLECTION_HOTEL28355,
} from "./firebaseConstants";

export function listenToBooking30512HotelFromFirestore(id: string) {
  return db.collection(COLLECTION_BOOKING30512_HOTEL).doc(id);
}
export async function addBooking30512HotelToFirestore(
  doc: Partial<IHotelBookingInput>,
) {
  try {
    const batch = db.batch();
    const countRef = db
      .collection(COLLECTION_BOOKING30512_HOTEL_COUNT)
      .doc("count");
    const bookingRef = db.collection(COLLECTION_BOOKING30512_HOTEL).doc();
    const count = (await countRef.get()).data();
    const nextBookingId = +(count?.count || 2607) + 1;
    let periodOffer: any = null;
    if (doc.exclusiveOfferId) {
      const currentPeriodOffer = await db
        .collection(COLLECTION_HOTEL28355)
        .doc(doc.hotelId)
        .collection(COLLECTION_EXCLUSIVEHOTEL64774)
        .doc(doc.exclusiveOfferId)
        .get();
      if (!currentPeriodOffer.exists) {
        throw new Error("The exclusive offer does not exist");
      }
      periodOffer = currentPeriodOffer.data();
    }

    const currentHotel = await db
      .collection(COLLECTION_HOTEL28355)
      .doc(doc.hotelId)
      .get();
    if (!currentHotel.exists) {
      throw new Error("The exclusive offer does not exist");
    }
    const hotel = currentHotel.data();

    batch.set(
      countRef,
      {
        count: firebase.firestore.FieldValue.increment(1),
      },
      { merge: true },
    );

    batch.set(bookingRef, {
      ...doc,
      bookingDate: firebase.firestore.FieldValue.serverTimestamp(),
      exclusiveOffer: periodOffer,
      hotel,
      status: "NEW",
      comment: "",
      bookingId: nextBookingId,
      // createBy: user,
    });
    await batch.commit();
    return bookingRef;
  } catch (err) {
    throw err;
  }
}

export function updateBooking30512HotelInFirestore(
  docId: string,
  doc: IHotelBookingInput | any,
) {
  console.log(doc);
  return db
    .collection(COLLECTION_BOOKING30512_HOTEL)
    .doc(docId)
    .update({
      ...doc,
    });
}
// export const addBooking30512HotelToFirestore = httpsCallable<
//   IHotelBookingInput,
//   IHotelBookingResponse
// >(functions, "bookingFunctions-hotelInitBookingToFirestore");

export function activeToggleBooking30512HotelInFirestore(
  docId: string,
  status: boolean,
) {
  return db.collection(COLLECTION_BOOKING30512_HOTEL).doc(docId).update({
    status,
  });
}

export function deleteBooking30512HotelInFirestore(docId: string) {
  return db.collection(COLLECTION_BOOKING30512_HOTEL).doc(docId).delete();
}
